var _circle, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnBtnHoverDel = function SvgIcnBtnHoverDel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "white",
    stroke: "#EDEDEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.833 7.5C12.2807 7.5 11.833 7.94772 11.833 8.5V8.58333H16.1663V8.5C16.1663 7.94772 15.7186 7.5 15.1663 7.5H12.833ZM8.58301 10.6667C8.58301 10.1144 9.03072 9.66667 9.58301 9.66667H9.66634H18.333H18.4163C18.9686 9.66667 19.4163 10.1144 19.4163 10.6667V10.8333C19.4163 11.3856 18.9686 11.8333 18.4163 11.8333H18.333V18.3333C18.333 19.53 17.363 20.5 16.1663 20.5H11.833C10.6364 20.5 9.66634 19.53 9.66634 18.3333V11.8333H9.58301C9.03072 11.8333 8.58301 11.3856 8.58301 10.8333V10.6667ZM17.2497 11.8333H10.7497V18.3333C10.7497 18.9316 11.2347 19.4167 11.833 19.4167H16.1663C16.7646 19.4167 17.2497 18.9316 17.2497 18.3333V11.8333Z",
    fill: "#A4A7AD"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBtnHoverDel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_btn_hover_del.08be99bd.svg";
export { ForwardRef as ReactComponent };